import { type IDropdownItem } from 'shared/ui'
import type { Inbox } from 'entities/Inbox/model/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu/store/conversationMenuStore'

const typeTeamsMute = 'mute'

type IActionTeamsMute = {
  inbox: Inbox
  item: IDropdownItem
}

export const menuTeamsMute = (inbox: Inbox): IDropdownItem => {
  if (inbox.type !== 'inbox') {
    return {
      id: typeTeamsMute,
      label: '',
    }
  }

  return {
    id: typeTeamsMute,
    iconL: inbox.isMuted ? 'bellFilled' : 'bell',
    label: inbox.isMuted ? 'Unmute inbox' : 'Mute inbox',
  }
}

export const actionTeamsMute = (
  { inbox, item }: IActionTeamsMute,
  store: ConversationMenuStore
) => {
  if (item.id === typeTeamsMute) {
    store.sharedApiMenuStore.onMute(inbox)
  }
}
